import AppRouter from "./router";

const App = () => <AppRouter />

export default App